import { render, staticRenderFns } from "./product_npbkcd3.vue?vue&type=template&id=bca676b0&scoped=true"
import script from "./product_npbkcd3.vue?vue&type=script&lang=js"
export * from "./product_npbkcd3.vue?vue&type=script&lang=js"
import style1 from "./product_npbkcd3.vue?vue&type=style&index=1&id=bca676b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca676b0",
  null
  
)

export default component.exports